import CategoryResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/CategoryResponse";
import { findPreferredTranslation } from "@/utils/languagePriority";

export default class CategoryViewModel {
    id: number;
    name: string;
    constructor(obj?: CategoryResponse | any) {
        if (obj != null) {
            const id = obj.Id ?? obj.id;
            this.id = id == null ? null : Number(id);
            const translations = obj.Translations || obj.translations || [];
            const translation = findPreferredTranslation(
                translations,
                (item: any) => Boolean(item && (item.Name || item.name))
            );
            this.name = translation ? translation.Name || translation.name || '' : '';
        }
    }
}
